import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "document",
  components: { VueJsonPretty },
  props: [],
  data() {
    return {
      chosenItem: "",
      expandedCard: false,
    };
  },
  computed: {},
  mounted() {
    this.chosenItem = "#item-01";
  },
  methods: {
    highlightItem(item) {
      this.chosenItem = item;
    },
    relevantPage() {
      if (this.chosenItem) {
        const item = this.chosenItem.substring(1);
        if (/item-04|item-06|item-07/g.test(item)) {
          this.expandedCard = false;
        } else {
          this.expandedCard = true;
        }
        if (item.match(/-/g).length > 1) {
          return item.substring(0, item.indexOf("-", 6));
        } else {
          return item;
        }
      }
    },
  },
};
